





















import { Vue, Component } from "vue-property-decorator"
import { Game } from "../models/game"
@Component
export default class PowerView extends Vue {
    get playerEnergy() {
        return this.$store.getters.playerEnergy
    }

    get minEnergy() {
        const state: Game = this.$store.state
        if (this.$store.state.minMwatts == null) {
            if (state.rounds != null) {
                return state.rounds[state.activeRound - 1].minEnergy
            }
        } else {
            return this.$store.state.minMwatts
        }
    }

    get pollution() {
        return this.$store.state.pollution
    }

    get pollutionThreshold() {
        return this.$store.state.pollutionThreshold
    }

    get powerLevel() {
        const val = (100 * (this.playerEnergy / this.minEnergy)) / 2
        if (val >= 100) {
            return 98
        } else if (val <= 0 || isNaN(val)) {
            return 0
        } else {
            return val
        }
    }

    get climateLevel() {
        const val = (100 * (this.pollution / this.pollutionThreshold)) * 0.80
        if (val >= 100) {
            return 98
        } else if (val <= 0 || isNaN(val)) {
            return 0
        } else {
            return val
        }
    }
}
